function HeaderReducer(states, action) {
  switch (action.type) {
    case "ISMEESENGER": {
      return {
        ...states,
        isMessenger: true,
        isSuggestion: false,
      };
    }
    case "ISSUGGESTION": {
      return {
        ...states,
        isMessenger: false,
        isSuggestion: true,
      };
    }
    case "ISPREREGISTRATION": {
      return {
        ...states,
        isMessenger: false,
        isSuggestion: false,
        isPreRegistration: action.data?.isPreRegistration,
        step: action.data?.step,
      };
    }
    case "MYPROFILE": {
      return {
        ...states,
        isMessenger: false,
        isSuggestion: false,
        myProfileUrl: action.data,
      };
    }

    case "HOMEDETAILS": {
      return {
        ...states,
        homeDetails: action.data,
      };
    }
    case "SHOWMENUBAR": {
      return {
        ...states,
        isMessenger: false,
        isSuggestion: false,
        showMenubar: action.data,
      };
    }
    default:
      return {
        ...states,
        isMessenger: false,
        isSuggestion: false,
      };
  }
}

export default HeaderReducer;
